import { Skeleton } from '@/components/ui/Skeleton.tsx';

const SettingApprovalPreviewSkeleton = () => (
  <div className="flex w-full flex-col gap-6">
    <div className="space-y-3">
      {Array.from({ length: 3 }, (_, i) => (
        <div key={i} className="flex flex-col md:flex-row md:gap-2">
          <Skeleton className="h-5 w-[120px]" />
          <Skeleton className="h-5 w-48" />
        </div>
      ))}
    </div>
    <Skeleton className="h-10 w-full rounded-md" />
  </div>
);

export default SettingApprovalPreviewSkeleton;
